import dayjs from 'dayjs';
import { curryRight, isNil } from 'lodash-es';

const toPercentage = (value) => Math.min(100, value * 100);

export function formatDate(dateString) {
  return dayjs(dateString).format('YYYY/MM/DD');
}

export const transformPercentageToDiscount = curryRight(
  (percentage, language) => {
    if (!['zh-hant', 'zh-cn'].includes(language)) {
      return String(percentage);
    }
    const discount = 100 - percentage;
    switch (true) {
      case discount === 0:
        return '0';
      case discount < 10:
        return String(discount / 10);
      default:
        return String(discount).replace(/0$/, '');
    }
  },
  2,
);

export function getProgressPercentage(tierGap) {
  // for updated yet common member
  if (isNil(tierGap.next_total_spending)) {
    return 0;
  }

  if (tierGap.extend_total_spending === 0) {
    return 100;
  }

  return toPercentage(
    (tierGap.user_spending ?? 0) / tierGap.next_total_spending,
  );
}

export function getExtendProgressPercentage(extendGap) {
  // for updated yet common member
  if (isNil(extendGap.extend_total_spending)) {
    return 0;
  }

  if (extendGap.extend_total_spending === 0) {
    return 100;
  }

  const userSpendingsForExtend = extendGap.user_spendings_for_extend ?? 0;
  return toPercentage(userSpendingsForExtend / extendGap.extend_total_spending);
}

export function getExtendBalanceStatusWordingConfig(
  extendRule,
  t,
  { dollar, spending },
) {
  return {
    singlePurchase: t('users.membership.tier.extend.single_purchase', {
      month: extendRule?.effect_interval.time_value,
      dollar,
    }),
    singlePurchaseCanExtend: t(
      'users.membership.tier.extend.single_purchase.can_extend',
      {
        month: extendRule?.effect_interval.time_value,
        dollar,
      },
    ),
    singlePurchaseTopLevel: t(
      'users.membership.tier.extend.top_level.single_purchase',
      {
        dollar,
      },
    ),
    singlePurchaseTopLevelCanExtend: t(
      'users.membership.tier.extend.top_level.single_purchase.can_extend',
      {
        dollar,
      },
    ),
    withinInterval: t('users.membership.tier.extend.within_interval', {
      month: extendRule?.effect_interval.time_value,
      spending,
      dollar,
    }),
    withinIntervalCanExtend: t(
      'users.membership.tier.extend.within_interval.can_extend',
      {
        month: extendRule?.effect_interval.time_value,
        dollar,
      },
    ),
    withinIntervalTopLevel: t(
      'users.membership.tier.extend.top_level.within_interval',
      {
        dollar,
      },
    ),
    withinIntervalTopLevelCanExtend: t(
      'users.membership.tier.extend.top_level.within_interval.can_extend',
    ),
  };
}
